__turbopack_context__.v({
  "map-card": "map-card-component-module-scss-module__2zU4bq__map-card",
  "map-card__action": "map-card-component-module-scss-module__2zU4bq__map-card__action",
  "map-card__actions": "map-card-component-module-scss-module__2zU4bq__map-card__actions",
  "map-card__back-btn-wrapper": "map-card-component-module-scss-module__2zU4bq__map-card__back-btn-wrapper",
  "map-card__dates": "map-card-component-module-scss-module__2zU4bq__map-card__dates",
  "map-card__dates-timestamps": "map-card-component-module-scss-module__2zU4bq__map-card__dates-timestamps",
  "map-card__day": "map-card-component-module-scss-module__2zU4bq__map-card__day",
  "map-card__product-availability": "map-card-component-module-scss-module__2zU4bq__map-card__product-availability",
  "map-card__store-assortments": "map-card-component-module-scss-module__2zU4bq__map-card__store-assortments",
  "map-card__store-assortments-header": "map-card-component-module-scss-module__2zU4bq__map-card__store-assortments-header",
  "map-card__store-assortments-item": "map-card-component-module-scss-module__2zU4bq__map-card__store-assortments-item",
  "map-card__store-info": "map-card-component-module-scss-module__2zU4bq__map-card__store-info",
});
